export enum AUTH_USER_DETAILS_ROW {
    authType = 'authType',
    bookInvites = 'bookInvites',
    membership = 'membership',
    annotations = 'annotations',
    bookAccess = 'bookAccess',
    mailingList = 'mailingList',
    annotationUpdates = 'annotationUpdates',
    hideAnnotations = 'hideAnnotations',
    customCursor = 'customCursor',
    saveReaderProgress = 'saveReaderProgress',
    signOutButton = 'signOutButton',
}
